"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roroRules = void 0;
const lodash_1 = require("lodash");
const board_1 = require("../board");
const common_1 = require("../common");
const constants_1 = require("../constants");
const Model_1 = require("../Model");
const players_1 = require("../players");
const shared_1 = require("./shared");
const standard_1 = require("./standard");
const roroGetMovesWithSteps = (state, steps) => {
    if (steps.length === 0) {
        return {};
    }
    if (isTwoOne(state.dice)) {
        return {};
    }
    if ((0, board_1.isOnBar)(state.board, state.turn)) {
        const mustPlay = (0, lodash_1.uniq)(steps).filter((p) => !(0, board_1.isOccupied)(state.board, (0, players_1.opponent)(state.turn), p));
        if (mustPlay.length > 0) {
            return {
                [Model_1.BAR_POINT]: mustPlay.map((step) => [
                    (0, common_1.addMoveInfo)((0, common_1.makeAMove)(Model_1.BAR_POINT, step), state),
                ]),
            };
        }
        return {};
    }
    if ((0, board_1.isReadyToBearOff)(state.board, state.turn)) {
        const mustPlay = (0, lodash_1.uniq)(steps).filter((p) => (0, board_1.countAtPoint)(state.board, state.turn, p) > 0);
        if (mustPlay.length > 0) {
            return mustPlay.reduce((acc, from) => {
                acc[from] = [[(0, common_1.addMoveInfo)((0, common_1.makeAMove)(from, from), state)]];
                return acc;
            }, {});
        }
        if (isSheshBesh(state.dice)) {
            return sheshBeshMoves(state, true);
        }
    }
    if (isSheshBesh(state.dice)) {
        return sheshBeshMoves(state, false);
    }
    return (0, standard_1.standardGetMovesWithSteps)(state, steps);
};
const roroFinalizeTurn = (state) => {
    const turn = (0, common_1.isDouble)(state.dice) || isSheshBesh(state.dice)
        ? state.turn
        : (0, players_1.opponent)(state.turn);
    return Object.assign(Object.assign({}, state), { turn, dice: null });
};
const roroUpdateSteps = (state, moves, steps) => {
    let newSteps = [...steps];
    moves.forEach((move) => {
        const si = newSteps.indexOf(move.step);
        if (si === -1 && isSheshBesh(state.dice)) {
            newSteps.pop();
        }
        newSteps = newSteps.filter((_, i) => i !== si);
    });
    return newSteps;
};
exports.roroRules = (0, shared_1.createRules)({
    getMovesWithSteps: roroGetMovesWithSteps,
    finalizeTurn: roroFinalizeTurn,
    updateSteps: roroUpdateSteps,
});
function isSheshBesh(dice) {
    return (0, common_1.diceEquals)(dice, constants_1.SHESH_BESH[0], constants_1.SHESH_BESH[1]);
}
function isTwoOne(dice) {
    return (0, common_1.diceEquals)(dice, constants_1.TWO_ONE[0], constants_1.TWO_ONE[1]);
}
function sheshBeshMoves(state, allowBearOff) {
    const playerPoints = (0, board_1.isOnBar)(state.board, state.turn)
        ? [Model_1.BAR_POINT]
        : (0, board_1.getPointsWithAtLeast)(state.board, state.turn, 1);
    const movesFromPoint = playerPoints.reduce((acc, from) => {
        var _a, _b;
        const allMoves = (0, lodash_1.times)(constants_1.NUM_POINTS, (to) => to + 1).reduce((movesAcc, to) => {
            if (to === from) {
                return movesAcc;
            }
            if ((0, board_1.isOccupied)(state.board, (0, players_1.opponent)(state.turn), (0, board_1.opponentPoint)(to))) {
                return movesAcc;
            }
            movesAcc.push([(0, common_1.makeAMove)(from, from - to)]);
            return movesAcc;
        }, []);
        if (allMoves.length > 0) {
            acc[from] = allMoves.map((moves) => moves.map((move) => (0, common_1.addMoveInfo)(move, state)));
        }
        if (allowBearOff) {
            acc[from] = (_a = acc[from]) !== null && _a !== void 0 ? _a : [];
            (_b = acc[from]) === null || _b === void 0 ? void 0 : _b.push([(0, common_1.addMoveInfo)((0, common_1.makeAMove)(from, from), state)]);
        }
        return acc;
    }, {});
    return movesFromPoint;
}
